import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface PurgeUserAccountResponse {
    success: boolean;
    deletedCounts: Record<string, number>;
    totalDeleted: number;
    message: string;
    creditsRefunded: number;
    refundBreakdown: Record<string, number>;
}

export function usePurgeUserAccount() {
    const queryClient = useQueryClient();

    return useMutation<PurgeUserAccountResponse, Error, number>({
        mutationFn: (userId) => api.post(`/api/admin/users/${userId}/purge`),
        onSuccess: (_, userId) => {
            // Invalidate user entities query
            queryClient.invalidateQueries({
                queryKey: ['admin', 'users', userId, 'entities'],
            });
            // Invalidate admin users list
            queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
        },
    });
}
